import { getSessionStoreKey as e } from "@systemeio/util";
import { useLocalStorage as t, useSessionStorage as n } from "usehooks-ts";
//#region src/modules/widget/hooks/use-widget-controlts.ts
var r = () => {
	let [r, i] = n(e("ai-chat-open"), !1), [a, o] = t(e("ai-chat-chat-open"), !0), [s, c] = t(e("ai-chat-history-open"), !1), [l, u] = t(e("ai-chat-fullscreen"), !1);
	return {
		open: r,
		setOpen: i,
		chatOpen: a,
		setChatOpen: o,
		historyOpen: s,
		setHistoryOpen: c,
		fullScreen: l,
		setFullScreen: u
	};
};
//#endregion
export { r as useWidgetControls };
